export const getFormattedDate = (date: Date | string) => {
    var d = new Date(date)
    var curr_date = d.getDate()
    var curr_month = d.getMonth()
    curr_month++ //We add +1 because Jan is indexed at 0 instead of 1
    var curr_year = d.getFullYear()

    return curr_date + '/' + curr_month + '/' + curr_year
  }